<template>
  <fragment>
    <v-row no-gutters justify="space-between" align="center" class="px-10 pt-5">
      <v-col cols="8" class="subtitle-1 font-weight-bold">
        {{ translations.selectProducts[lang] }}
      </v-col>
      <!-- <v-col cols="auto">
                <v-img
                    src="@/assets/new-transaction-basket.png"
                    width="90"
                    class="rounded-circle"
                ></v-img>
            </v-col> -->

      <!-- <v-col cols="6" style="font-size: 0.875rem">
                <div>
                    {{ transaction.products.length }}
                    {{ translations.productsSelected[lang] }}
                </div>
                <div>
                    {{ transactionPreview.won_points || 0 }}
                    {{ translations.pointsWon[lang] }}
                </div>
                <div>
                    {{ transactionPreview.lost_points || 0 }}
                    {{ translations.pointsLost[lang] }}
                </div>

                <div style="height: 2px">
                    <v-progress-linear
                        color="secondary"
                        :indeterminate="previewLoading"
                        :active="previewLoading"
                        height="2"
                    ></v-progress-linear>
                </div>
            </v-col> -->

      <v-col cols="auto">
        <v-btn color="secondary" class="text-capitalize pr-6" depressed @click.stop="dialog = true">
          <v-icon class="mr-2" v-text="icons.mdiPlus"></v-icon>
          {{ translations.addProducts[lang] }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="px-10">
      <v-col>
        <div>
          {{ transaction.products.length }}
          {{ translations.productsSelected[lang] }}
          -
          {{ transactionPreview.won_points || 0 }}
          {{ translations[`${storeMode}Won`][lang] }}
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="500" content-class="stable-height-600">
      <b-card
        :title="translations.orderProducts[lang]"
        @cancel="dialog = false"
        @submit="submitDialog"
        :cancelBtn="false"
        :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
        sticky-footer
      >
        <v-col cols="12" class="pa-0">
          <v-text-field
            v-model="search"
            class="mt-1"
            :label="translations.search[lang]"
            color="secondary"
            outlined
            clearable
            rounded
            dense
            hide-details
            :prepend-inner-icon="icons.mdiMagnify"
          >
          </v-text-field>
        </v-col>
        <div v-if="products.length">
          <v-checkbox
            v-for="item in products"
            :key="item.product_id"
            :input-value="item.selected"
            hide-details
            @click="productSelect(item)"
          >
            <template v-slot:label>
              <v-row no-gutters justify="space-between">
                <v-col cols="auto">
                  {{ item.name[lang] }} ({{
                    new Intl.NumberFormat('en-US', {
                      style: 'currency',
                      currency: 'EUR',
                      minimumFractionDigits: 2,
                    }).format(item.retail_price)
                  }})
                </v-col>

                <v-col cols="auto" :class="item.available_today ? 'green--text' : 'red--text'">
                  {{
                    item.available_today
                      ? translations.available[lang]
                      : translations.notAvailable[lang]
                  }}
                </v-col>
              </v-row>
            </template>
          </v-checkbox>
          <v-col
            v-if="
              (productsPagination.total_pages || 1) > 1 &&
              productsPage < (productsPagination.total_pages || 1)
            "
            cols="12"
            class="d-flex justify-center"
          >
            <v-card v-intersect="infiniteScrolling"> </v-card>
          </v-col>
        </div>
        <div v-else>
          <v-col cols="12" class="d-flex pa-5 justify-center">
            <div class="d-flex flex-column align-center">
              <v-subheader>{{ translations.noResultsFound[lang] }}</v-subheader>
            </div>
          </v-col>
        </div>
        <div v-if="productsLoading" class="d-flex justify-center align-center">
          <v-progress-circular indeterminate color="secondary" size="64"></v-progress-circular>
        </div>
        <div
          v-if="productsPage < productsPagination.total_pages"
          v-intersect="infiniteScrolling"
        ></div>
      </b-card>
    </v-dialog>
    <v-row no-gutters class="pa-6 b-bottom-outlined">
      <v-col
        v-for="(product, i) in transaction.products"
        :key="product.product_id"
        cols="4"
        class="pa-2"
      >
        <v-card tile outlined>
          <v-card-title class="subtitle-2 font-weight-bold pa-0 pl-3">
            <v-col cols="9" class="pa-0 text-truncate">
              {{ product.name[lang] }}
            </v-col>

            <v-col cols="auto" class="pa-0">
              <v-btn color="red" icon @click="productRemove(product, i)">
                <v-icon v-text="icons.mdiClose"></v-icon>
              </v-btn>
            </v-col>
          </v-card-title>
          <div style="font-size: 0.8rem" class="pl-3 mt-n2 text--secondary font-weight-medium">
            {{
              transactionPreview.products.length && transactionPreview.products[i]
                ? transactionPreview.products[i].points_per_row
                : 0
            }}
            {{ translations[storeMode][lang] }}
          </div>

          <v-divider class="mt-1"></v-divider>

          <div class="pt-1 pb-3">
            <price-field
              v-if="
                product.reward_type_id === 1 ||
                product.reward_type_id === 2 ||
                product.reward_type_id === 4
              "
              v-model="product.retail_price"
              :label="translations.amount[lang]"
              prepend-inner-icon="mdiCurrencyEur"
              :max-price="product.maximum_price_per_transaction"
              @get-transaction="debouncedGetTransactionPreview"
            ></price-field>

            <template v-else>
              <quantity-field
                v-model="product.quantity"
                :label="translations.quantity[lang]"
                @get-transaction="debouncedGetTransactionPreview"
              ></quantity-field>

              <template v-if="product.product_coupons">
                <b-select
                  v-if="product.product_coupons.length"
                  v-model="product.product_coupons_for_use"
                  :items="product.product_coupons"
                  :item-text="`text[${lang}]`"
                  return-object
                  :label="translations.selectCoupon[lang]"
                  class="ma-3"
                  no-top-margin
                  no-clear-icon
                  multiple
                ></b-select>
              </template>
            </template>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="showNotification" color="error" multi-line top>
      <v-icon class="mr-1" v-text="icons.mdiAlert"></v-icon>
      <span class="subtitle-1 font-weight-bold">
        Sorry, the product you selected is not available today
      </span>
      <template v-slot:action>
        <v-btn icon @click="showNotification = false">
          <v-icon v-text="icons.mdiClose"></v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </fragment>
</template>

<script>
import {
  mdiPlus,
  mdiClose,
  mdiMenuUp,
  mdiMenuDown,
  mdiCheckBoxOutline,
  mdiCheckboxBlankOutline,
  mdiAlert,
  mdiMagnify,
} from '@mdi/js';

import { mapState, mapMutations, mapActions } from 'vuex';
import debounce from 'lodash/debounce';

import { Fragment } from 'vue-frag';
import QuantityField from './QuantityField.vue';
import PriceField from './PriceField.vue';
import TransactionProduct from '@/models/storePanel/TransactionProduct';
import translations from '@/utils/translations/storePanel/newTransaction/products';

export default {
  name: 'NewTransactionProducts',

  components: { Fragment, QuantityField, PriceField },

  mixins: [translations],

  data: () => {
    return {
      productsPage: 1,
      icons: {
        mdiPlus,
        mdiClose,
        mdiMenuUp,
        mdiMenuDown,
        mdiCheckBoxOutline,
        mdiCheckboxBlankOutline,
        mdiAlert,
        mdiMagnify,
      },
      menu: false,
      search: '',
      success: false,
      error: '',
      productRequired: {
        el: '',
        en: 'You must choose at least 1 product',
        it: '',
      },
      showNotification: false,
    };
  },

  computed: {
    ...mapState(['resetValidation']),
    ...mapState('storePanel/transactions', [
      'previewLoading',
      'transactionPreview',
      'productsLoading',
      'products',
      'transaction',
      'productsPagination',
    ]),

    lang() {
      return this.$route.params.lang;
    },
    storeMode() {
      return this.$store.state.store?.display_mode || 'points';
    },
    dialog: {
      get() {
        return this.$store.state.dialog;
      },

      set(val) {
        this.setDialog(val);
      },
    },

    selectedProducts: {
      get() {
        return this.$store.state.storePanel.transactions.selectedProducts;
      },

      set(val) {
        this.setSelectedProducts(val);
      },
    },

    productsPaginationText() {
      return this.productsPagination.current_page && this.productsPagination.total
        ? `${this.productsPagination.current_page * 12 - 11}-${
            this.productsPagination.current_page * 12 <= this.productsPagination.total
              ? this.productsPagination.current_page * 12
              : this.productsPagination.total
          } ${this.translations.paginationText[this.lang]} ${this.productsPagination.total}`
        : ``;
    },
  },

  methods: {
    ...mapMutations(['setDialog', 'setResetValidation']),
    ...mapMutations('storePanel/transactions', ['setSelectedProducts', 'setProducts']),
    ...mapActions('storePanel/transactions', ['getProducts', 'getTransactionPreview']),

    productSelect(item) {
      if (!item.available_today) {
        this.showNotification = true;
      } else {
        item.selected = !item.selected;
        const selectedProducts = this.selectedProducts;

        let index = selectedProducts.findIndex((p) => p.product_id === item.product_id);

        if (index === -1) {
          selectedProducts.push(item);
        } else {
          selectedProducts.splice(index, 1);
        }

        if (!item.selected) this.debouncedGetTransactionPreview(true);
        this.selectedProducts = JSON.parse(JSON.stringify(selectedProducts));
      }
    },

    productRemove(item, index) {
      this.selectedProducts.splice(index, 1);
      let product = this.products.find((p) => p.product_id === item.product_id);
      if (product) product.selected = false;
      this.debouncedGetTransactionPreview(true);
    },

    handleSearch() {
      this.productsPage = 1;
      this.getProducts({
        query: `?q=${this.search}`,
        page: this.productsPage,
      });
    },

    handleGetTransactionPreview() {
      this.getTransactionPreview(true);
    },

    validateProductsInput() {
      if (!this.selectedProducts.length) {
        this.error = this.productRequired[this.lang];
      } else {
        this.error = '';
      }
    },
    infiniteScrolling(entries, observer, isIntersecting) {
      if (!this.productsLoading) {
        this.productsPage++;
        let query = '?page=' + this.productsPage;
        if (this.search?.length) {
          query += '&q=' + this.search;
        }
        this.getProducts({ query, page: this.productsPage });
      }
    },
    submitDialog() {
      this.dialog = false;
      if (this.success) {
        this.$emit('update-products-success', true);
      } else {
        this.$emit('update-products-success', false);
      }
    },
  },

  watch: {
    selectedProducts(val) {
      this.success = !!val.length;

      if (val.length) {
        this.error = '';
      } else {
        this.error = this.productRequired[this.lang];
      }

      val.forEach((selected) => {
        let product = this.transaction.products.find((p) => p.product_id === selected.product_id);
        if (product) {
          selected.quantity = Number(product.quantity);
          selected.retail_price = product.retail_price;
        } else {
          if (
            selected.reward_type_id === 1 ||
            selected.reward_type_id === 2 ||
            selected.reward_type_id === 4
          )
            selected.retail_price = null;
        }
      });

      this.transaction.products = [];

      val.forEach((p) => {
        this.transaction.products.push(new TransactionProduct(p));
      });
    },

    search(val) {
      this.menu = true;
      if (val) {
        this.debouncedSearch();
      } else {
        this.productsPage = 1;
        this.getProducts({ query: `?page=1`, page: 1 });
      }
    },

    dialog(val) {
      if (val) {
        this.$emit('update-products-success', false);
      } else {
        if (this.success) {
          this.$emit('update-products-success', true);
        } else {
          this.$emit('update-products-success', false);
        }
      }
    },

    resetValidation(val) {
      if (val) {
        this.error = '';
        this.setResetValidation(false);
      }
    },
  },

  created() {
    this.debouncedSearch = debounce(this.handleSearch, 500);
    this.debouncedGetTransactionPreview = debounce(this.handleGetTransactionPreview, 500);
  },

  mounted() {
    this.getProducts({ query: `?page=1`, page: 1 });
  },

  beforeDestroy() {
    this.selectedProducts = [];
    this.setProducts([]);
  },
};
</script>

<style>
.stable-height-600 {
  height: 600px !important;
  max-height: 600px !important;
  min-height: 600px !important;
}
.stable-height-600 .v-card {
  min-height: 600px !important;
}

.stable-height-600 .v-form {
  min-height: 484px !important;
}

.v-pagination * {
  box-shadow: none;
}
.v-pagination__item {
  box-shadow: none;
}
.v-application .primary {
  background-color: #2a3042 !important;
  border-color: #2a3042 !important;
}
</style>
<style scoped>
.b-list-active {
  background-color: rgba(42, 48, 66, 0.12);
  color: rgb(42, 48, 66);
}
</style>
